export default __webpack_public_path__ + "static/media/logo-white.8d62753c.svg";